import Api from "./api";
import OidcManager from "./oidcManager";

export interface Instance {
    sessionKey: string;
    active: boolean;
}

export class InstancesApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    getNewId(): JQueryPromise<Instance> {
        return super.get("/api/instances/",{});
    }
    getById(id:string): JQueryPromise<Instance> {
        return super.get("/api/instances/" + id,{});
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/instances.ts